export const deleteAnnotation = (widget) => {
    widget.deleteAnnotation();
};

export const setHighlightTextColor = (widget, color) => {
    widget.setHighlightColor(color);
};

export const setFreeTextFontColor = (widget, color) => {
    widget.setFreeTextColor(color);
};

export const setFreeTextFontSize = (widget, fontSize) => {
    widget.setFreeTextFontSize(fontSize);
};

export const setAnnotationEditorMode = (widget, args) => {
    if (widget.interactionMode !== args.mode) {
        widget.setInteractionMode({
            mode: args.mode
        });
    }

    widget.setAnnotationEditorMode(args);
};

export const resetAnnotationEditorMode = (widget) => {
    widget.resetAnnotationEditorMode();
};

export const setInteractionMode = (widget, mode) => {
    widget.setInteractionMode({ mode: mode });
};